import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useMechanicalByHeatContext } from "../MechanicalByHeatContext";

export const useHeatNavigation = () => {
	const { state, actions } = useMechanicalByHeatContext();
	const navigate = useNavigate();
	const { heatName } = useParams();
	const [params] = useSearchParams();
	const validParam = params.get("valid") ?? "false";

	const handleValidSamples = (checked: boolean) => {
		actions.setShowOnlyValid(checked);
		navigate(`/lab-mechanical-by-heat/${heatName ?? ""}?valid=${checked}`);
	};

	const nextHeat = () => {
		if (!state.heat) return;
		const current = state.resultHeats?.find(
			(h) => h.HeatId === state.heat!.HeatId,
		);
		if (current?.NextHeatId && current?.NextHeatName) {
			actions.setSearchHeatNameText(current.NextHeatName);
			actions.setHeat({ Id: current.NextHeatId, Name: current.NextHeatName });
			navigate(
				`/lab-mechanical-by-heat/${current.NextHeatName}?valid=${validParam}`,
			);
		}
	};

	const previousHeat = () => {
		if (!state.heat) return;
		const current = state.resultHeats?.find(
			(h) => h.HeatId === state.heat!.HeatId,
		);
		if (current?.PreviousHeatId && current?.PreviousHeatName) {
			actions.setSearchHeatNameText(current.PreviousHeatName);
			actions.setHeat({
				Id: current.PreviousHeatId,
				Name: current.PreviousHeatName,
			});
			navigate(
				`/lab-mechanical-by-heat/${current.PreviousHeatName}?valid=${validParam}`,
			);
		}
	};

	return {
		handleValidSamples,
		nextHeat,
		previousHeat,
	};
};
